/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export default function CalendarLayout() {
  return (
    <div>
      <div>
        <h2 className="helpHeaderTitle">Scheduling Content </h2>
        <div className="helpContentSection">
          {" "}
          <div className="imageRow mb-3">
            <div className="imageSection">
              {" "}
              <img
                alt=""
                src={require("../../assets/images/helpCenter/calendarCenterImg1.png")}
              />
            </div>
            <div className="imageInfoSection">
              <div className="boldTitle">Create Calendar </div>
              <div>
                In the Calendar tab click “Create calendar” or edit an existing
                calendar by clicking on its title. Calendars must be created for
                each corresponding form factor that will be used.
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Create a New Calendar Event</div>
            <div>
              Click on the column of the day you’d like to add the event and the
              New Calendar Event window will pop up to enter required
              information.
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Edit a Calendar Event</div>
            <ul className="ml-2 mb-3">
              <li className="questionRow ml-0 mr-0">
                <p className="questionSection">1.</p>{" "}
                <p className="answerSection">
                  Select the campaign you would like to play from the dropdown
                  by clicking the “Campaign Name” field
                </p>
              </li>
              <li className="questionRow ml-0 mr-0">
                <p className="questionSection">2.</p>{" "}
                <p className="answerSection">
                  Type in an Event Name (ie. “Rock and Roll Marathon”)
                </p>
              </li>
              <li className="questionRow ml-0 mr-0">
                <p className="questionSection">3.</p>{" "}
                <p className="answerSection">
                  Select the start date/time and end date/time of the event.
                </p>
              </li>
              <li className="questionRow ml-0 mr-0">
                <p className="questionSection">4.</p>{" "}
                <p className="answerSection">
                  There is an optional “Repeat” field where you can set up that
                  specific calendar event to repeat daily, weekly, or monthly.
                </p>
              </li>
            </ul>{" "}
            <img
              alt=""
              src={require("../../assets/images/helpCenter/calendarCenterImg2.png")}
            />
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Save a Schedule</div>
            <div>
              Click “Save” for the individual calendar event and “Save as
              Calendar” for a new calendar or “Update Calendar” for an existing
              calendar.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/calendarCenterImg3.png")}
          />
        </div>
      </div>
    </div>
  );
}
